import React from 'react';
import {Card, CardContent, Typography, Grid, Box, Divider} from '@mui/material';
import {ServiceAgreementProps} from '../../components/AurServiceAgreementDropdown';
import AurCountryFlag from '../../../../common/aur-country-flag/AurCountryFlag';
import {t} from 'i18next';

const ServiceAgreementCard: React.FC<ServiceAgreementProps> = ({
  engagementName,
  engagementCode,
  geography,
  countryName,
  serviceType,
  engagementType,
  eciAccessEnabled,
  reviewPlatform,
}) => {
  const InfoItem: React.FC<{
    label: string;
    value: React.ReactNode;
    classNames?: string;
  }> = ({label, value, classNames}) => (
    <Grid item xs={12} sm={6} className={`${classNames}`}>
      <Typography className="typo-text label2_size service-agreement-item-title">
        {label}
      </Typography>
      <Typography className="typo-text subhead4_size">{value}</Typography>
    </Grid>
  );
  const stringPath =
    'projectCreation.serviceAgreementSelectionPage.serviceAgreementCard.';

  return (
    <Card className="service-agreement-card">
      <CardContent className="service-agreement-card-content">
        <Box
          className="service-agreement-item-content"
          display="flex"
          alignItems="center"
        >
          <Typography className="typo-text subhead4_size">
            [{engagementName}]
          </Typography>
          <Divider
            orientation="vertical"
            flexItem
            sx={{mx: 1}}
            className="divider"
          />
          <Typography className="typo-text body2_size">
            {engagementCode || ''}
          </Typography>
        </Box>
        <Grid container spacing={4}>
          <InfoItem label={t(stringPath + 'type')} value={engagementType} />
          <InfoItem
            label={t(stringPath + 'eci')}
            value={t(
              `projectCreation.common.${eciAccessEnabled ? 'enabled' : 'disabled'}`
            )}
          />
          <InfoItem
            label={t(stringPath + 'review')}
            value={reviewPlatform}
            classNames="service-agreement-grid"
          />
          <InfoItem
            classNames="service-agreement-grid"
            label={t(stringPath + 'geography')}
            value={
              <>
                <span aria-label={countryName}>
                  <AurCountryFlag
                    countryCode={geography}
                    altText={''}
                  />
                </span>{' '}
                {countryName}
              </>
            }
          />
          <InfoItem
            classNames="service-agreement-grid"
            label={t(stringPath + 'projectServiceType')}
            value={serviceType}
          />
        </Grid>
      </CardContent>
    </Card>
  );
};

export default ServiceAgreementCard;
